import {
  LOCALIZATIONS_GET,
  LOCALIZATIONS_GET_SUCCESS,
  LOCALIZATIONS_GET_ERROR,
} from './type'

//eslint-disable-next-line
export default function (
  state = {
    strings: {},
    labels: {},
    selected: 'en',
    loading: false,
    error: null,
  },
  action,
) {
  const { payload, type } = action

  switch (type) {
    case LOCALIZATIONS_GET:
      return { ...state, loading: true, error: null }
    case LOCALIZATIONS_GET_SUCCESS:
      return {
        ...state,
        strings: payload.response.strings || {},
        labels: payload.response.labels || {},
        selected: payload.response.selected || state.selected,
        loading: false,
        error: null,
      }
    case LOCALIZATIONS_GET_ERROR:
      return { ...state, loading: false, error: payload.error }
    default:
      return state
  }
}
